import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const StyledNavLink = styled(NavLink)`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;

    &:link,
    &:visited {
        color: ${tokens.text.primary};
        text-decoration: none;
    }
    &:hover, &:focus-visible {
    color: ${tokens.text.link};
        text-decoration: underline;
    }

    &:active {
        color: ${tokens.text.linkHover};
    }
` as NavLink;
